<template>
	<div class="imc_load">
		<file-pond
			name="getorder_loader"
			ref="pond"
			allow-multiple="true"
			:server=getConfig()
			:label-idle="__t('PUSH_FILE_LOADER')"
			v-bind:files="myFiles"
            @activatefile="openFile"
			v-on:init="handleFilePondInit"
		/>
	</div>
</template>

<script>
import  vueFilePond,{ setOptions  } from 'vue-filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'

const  FilePond = vueFilePond(
	FilePondPluginFileValidateType,
	FilePondPluginImagePreview ,
)

setOptions({
	labelFileProcessingComplete: 'Завантаження завершено',
	labelFileProcessing : "Loading",
	labelTapToUndo : 'Натисніть щоб видалити',
	labelInvalidField :'Файл містить заборонений тип',
	imagePreviewMaxHeight : 200,
	allowImageTransform:false,
	imageTransformOutputStripImageHead: false,
	forceRevert:true,
});

export default {
	name: "fileload",
	data: function () {
		return {
			myFiles: [],
			user_id: 0,
		}
	},

	props: {
		files : {
			type : Array,
			default() {
				return []
			}
		},

		doc_id : {
			type: Number,
			default: -1,
		},

		doc_type : {
			type : String,
			required : true,
		},

		url_load: {
			type: String,
			default: 'media/it_type/it_id',
		},

		url_remove: {
			type: String,
			default: '/media',
		},

        open_file : {
            type : Boolean,
            default : false,
        }

	},
	components: {
		FilePond,
	},

	created() {
		this.load_files();
        EventBus.$on('reset_files',this.reset_files)
	},

	computed: {

	},
	methods: {
        openFile(file) {
            if (file.source && this.open_file) {
                window.open(file.source, '_blank');
            }
        },


        removeFromPond(fileId) {
            const pond = this.$refs.pond;

            if (!pond) return;

            const pondFile = pond.getFiles().find(item => {
                return String(item.serverId) === String(fileId);
            });

            if (pondFile) {
                pond.removeFile(pondFile.id, {
                    revert: false,
                });
            }
        },

        clearPondFiles() {
            const pond = this.$refs.pond;

            if (!pond) return;

            pond.getFiles().forEach(item => {
                pond.removeFile(item.id, {
                    revert: false,
                });
            });

            this.myFiles = [];
        },

        reset_files() {
            this.clearPondFiles();
        },

		async load_files() {
			if(this.doc_id > 0) {
				this.$emit("on_load", true);
				this.myFiles = [];

                media_api.get('/media/'+ this.doc_type +'/' + this.doc_id).then(({data}) => {
					this.$emit("on_load", false);
					if (data.status === "operation_success") {
						this.push_files(data.data);
					}
				}).catch(({response}) => {
					this.$emit("on_load", false);
					EventBus.$emit('show_toast', {
						err: response.data.message, type: "danger",
						title: response.data.status,
						postion: "b-toaster-top-left"
					})
				});
			}
		},

		push_files(files) {
			if(files.length  > 0) {
				for (let i = 0; i < files.length; i++) {
					let fl = {
						source: files[i].resource_url,
						options: {
							type: "local",
						},
						file: {
							id:   files[i].id,
							name: files[i].filename,
							size: files[i].size,
							type: files[i].mime_type
						},
					};
					this.myFiles.push(fl);
				}
			}
		},

		handleFilePondInit() {

		},

		getConfig () {
			return {
				url: '/',
				timeout: 7000,

				process:(fieldName, file, metadata, load, error, progress, abort, transfer, options) => {


					let self = this;
					// fieldName is the name of the input field
					// file is the actual file object to send
					const formData = new FormData();
					formData.append(fieldName, file, file.name);

					//formData.append('imc_file[doc_id]', this.doc_id);
					//formData.append('imc_file[doc_type]', this.doc_type);

					let url_load = this.url_load
                        .replace("it_id",this.doc_id)
                        .replace("it_type",this.doc_type);

					const request = new XMLHttpRequest();
					request.open('POST', media_api.defaults.baseURL + url_load);
                    request.setRequestHeader( 'X-CSRF-TOKEN',document.head.querySelector('meta[name="csrf-token"]').content);
                    request.setRequestHeader('Authorization',media_api.defaults.headers.Authorization)

                    request.setRequestHeader("X-Requested-With","XMLHttpRequest");
                    request.setRequestHeader('Accept', 'application/json');
                    request.upload.onprogress = (e) => {
						progress(e.lengthComputable, e.loaded, e.total);
					};

					request.onload = function () {
						if (request.status >= 200 && request.status < 300) {
							let load_result = JSON.parse(request.responseText);
							console.warn('load_result:', load_result);

							if (load_result !== undefined) {
								let status = load_result.status;
								if (status === 'operation_success') {
									let file = load_result.data;

                                    self.$emit("finish_load", file);
									EventBus.$emit('loader_load_file', {
										'type': 'file_loaded',
										'file_id': file.id,
										'doc_id': self.doc_id,
										'doc_type': self.doc_type,
									});

									load(file.id);
								} else {
									error('SRV Err');
									EventBus.$emit('show_toast', {
										err: load_result.message,
										type: "danger",
										title: 'Ошибка сохранения'
									});

								}
							} else {
								// Can call the error method if something is wrong, should exit after
								error('oh no');
								EventBus.$emit('show_toast', {err: 'Empty Response', type: "danger", title:  self.__t("SAVE_FILE_ERR")})
							}
						}

						else {
							error('oh no');
							EventBus.$emit('show_toast', {
								err: 'SRV err',
								type: "danger",
								title: self.__t("SAVE_FILE_ERR")
							});
						}
					};

					request.send(formData);

					// Should expose an abort method so the request can be cancelled
					return {
						abort: () => {
							// This function is entered if the user has tapped the cancel button
							request.abort();
							// Let FilePond know the request has been cancelled
							abort();
						}
					};
				},

				remove: (source, load, error) => {
					let self = this;
					this.myFiles.map(item => {
						if(item.source === source) {
							self.remove_file_byid(item.file.id,'remove',res => {
								if(res == null) {
									error('can remove');
								} else {
									load();
								}
							},error);
						}
					});
				},

				revert : (uniqueFileId, load, error) => {
					console.log('revert',uniqueFileId);
					let self = this;
					this.remove_file_byid(uniqueFileId,'revert',function(res){
						if(res == null) {
							error('can remove');
						} else {
							load();
						}
					},error);
				},

				restore: null,

                load: (src, load) => {
                    fetch(src)
                        .then(res => res.blob())
                        .then(load);
                },

				fetch: null
			}
		},


		async remove_file_byid(uniqueFileId,rem_type,callback,e_f) {
			console.log('removing.........', uniqueFileId);

			await media_api.delete(this.url_remove + "/"  + uniqueFileId, {data: {
				'file_id': uniqueFileId,
				 rem_type : rem_type
			}}).then(({data}) => {
				if (data.status === "operation_success") {
					EventBus.$emit('loader_remove_file',{
						'type'      : 'file_deleted',
						'file_id'   : uniqueFileId,
						'doc_id'    : this.doc_id,
						'doc_type'  : this.doc_type,
					});
					callback(data);
				}
				else {
					e_f('oops');
					callback(null);
				}
			}).catch(err => {
				if(e_f != undefined) {
					e_f('oops');
					callback(null);
				}
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.status})
				console.log(err);
			});
		},
	},

}
</script>

<style scoped>
#files_added_imc {
	display: none;
}
</style>
